import { useState } from "react";
import { useNavigate } from "react-router-dom";

export function AdminLoginPage() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    const res = await fetch("/api/admin/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ password }),
    });
    if (res.ok) navigate("/admin/songs");
    else setError("Mot de passe incorrect");
  };

  return (
    <div className="max-w-sm mx-auto cw-panel p-8">
      <h1 className="cw-title text-2xl font-bold mb-6">Administration</h1>
      <form onSubmit={handleLogin} className="space-y-4">
        <input type="password" className="cw-input" placeholder="Mot de passe admin"
          value={password} onChange={(e) => setPassword(e.target.value)} aria-label="Mot de passe" />
        {error && <p className="text-red-400 text-sm">{error}</p>}
        <button type="submit" className="cw-btn cw-btn-primary w-full">Connexion</button>
      </form>
    </div>
  );
}
